// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Space, Text } from '@mantine/core';
import { FC, useContext } from 'react';
import { useElementSize } from '@mantine/hooks';
import { ProfileContext } from '../../../Service/Context/ProfileContext';

const PositionHeader: FC<{
  documentVersion: boolean;
  desktopVersion: boolean;
  showDiscount: boolean;
  showFinancialFields?: boolean;
  currencySymbol?: string;
  isPartialInvouce?: boolean;
}> = ({
  documentVersion,
  desktopVersion,
  showDiscount = true,
  showFinancialFields = true,
  currencySymbol = '€',
  isPartialInvouce = false,
}) => {
  const { profile } = useContext(ProfileContext);
  const { ref, width } = useElementSize();

  return (
    <Group
      ref={ref}
      spacing="xs"
      p={6}
      sx={(theme) => ({
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.colors.silver[9],
        borderRadius: 6,
        color: 'white',
        fontSize: 12,
      })}
    >
      {desktopVersion ? (
        <>
          {documentVersion && <Space w={35} />}
          <Text
            ml={documentVersion ? 0 : 'xs'}
            sx={{ width: width - (isPartialInvouce ? 500 : showFinancialFields ? 630 : 240) }}
          >
            Produkt/Leistung
          </Text>
          <Text sx={{ width: 50 }}>Menge</Text>
          <Text sx={{ width: 60 }}>Einheit</Text>
          {showFinancialFields && (
            <>
              <Text sx={{ width: 70 }}>{`Preis (${currencySymbol})`}</Text>
              {profile && !profile.smallScaleBusiness && <Text sx={{ width: 60 }}>Steuer (%)</Text>}
              {showDiscount && <Text sx={{ width: 130 }}>Rabatt</Text>}
              <Text align="center" sx={{ width: 100 }}>
                Gesamt
              </Text>
            </>
          )}
        </>
      ) : (
        <Text ml="xs">Positionen</Text>
      )}
    </Group>
  );
};

export default PositionHeader;
